// extracted by mini-css-extract-plugin
module.exports = {"burger":"Layout-module--burger--3rVAm","burgers":"Layout-module--burgers--hS9Kd","mainMarginTop":"Layout-module--mainMarginTop--2apBx"};